'use strict';

require("core-js/modules/es6.object.freeze");

module.exports = {};

if ('production' != process.env.NODE_ENV) {
  Object.freeze(module.exports);
}